<style>
.app-presentation__title span{
  color: #4da8bb;
}
</style>

<template>
  <section class="app-presentation">
    <h2 class="app-presentation__title">
      Ao integrar-se ao Marketplace, você usufrui da plataforma
      <br>
      Dr. Conecta com <span>50% de desconto</span> na mensalidade.
    </h2>

    <p class="app-presentation__text">
      Além da integração com o Marketplace você conta com um
      link do seu consultório virtual que poderá ser divulgado
      a seus pacientes, eles visualizam seus horários disponíveis,
      e podem agendar pagando com cartão de crédito o preço
      de sua consulta particular e você recebe em sua conta corrente
      cadastrada.
    </p>

    <router-link
      :to="{ name: 'DoctorAppIntegrationEducation' }"
      class="app-presentation__call-to-action btn-purple"
      tag="div"
    >
      <span>Integrar Agora</span>
    </router-link>

    <div class="app-presentation__wrapper">
      <div class="app-presentation__col">
        <p class="app-presentation__text">
         O Paciente seleciona a especialidade
         <br>
         e visualiza as opções de horário.
        </p>

        <div class="app-presentation__img">
          <img :src="require('@/assets/img/app-integration/app-presentation-step-1.png')" />
        </div>
      </div>

      <div class="app-presentation__col">
        <p class="app-presentation__text">
          Após selecionar o horário o paciente confirma
          <br>
          o pagamento e garante seu agendamento.
        </p>

        <div class="app-presentation__img">
          <img :src="require('@/assets/img/app-integration/app-presentation-step-2.png')" />
        </div>
      </div>
    </div>

    <div class="app-presentation__wrapper">
      <div class="app-presentation__col app-presentation__col--full">
        <p class="app-presentation__text">
          Você terá uma página de perfil exclusiva na internet,
          com seus horários disponíveis para receber consultas.
          <br>
          Você poderá compartilhar o link do seu perfil público
          com qualquer pessoa que queira agendar
          <br>
          uma consulta e já efetuar o pagamento durante o
          agendamento.
        </p>

        <div class="app-presentation__img">
          <img :src="require('@/assets/img/app-integration/app-presentation-step-4.png')" />
        </div>
      </div>
    </div>

    <router-link
      :to="{ name: 'DoctorAppIntegrationEducation' }"
      class="app-presentation__call-to-action btn-purple"
      style="margin-bottom: 5rem;"
      tag="div"
    >
      <span>Integrar Agora</span>
    </router-link>
  </section>
</template>

<script>
export default {
  name: 'AppIntegrationPresentation',

  props: {
    doctor: {
      type: Object,
      required: true,
      default: () => {}
    }
  },

  mounted () {
    this.fn_HIDE_PROGRESS()
  }
}
</script>
